import { forwardRef, memo } from "react"

import { LinkProps, Link as RouterLink } from "react-router"

/**
 * Link component for rendering a router-aware anchor tag using react-router.
 *
 * @param {Omit<LinkProps, "to"> & { href: string }} props - The props for the Link component.
 * @returns {JSX.Element} The rendered link.
 */
export const Link = forwardRef<HTMLAnchorElement, Omit<LinkProps, "to"> & { href: string }>(
  ({ href, ...props }, ref) => <RouterLink ref={ref} to={href} {...props} />
)
export default memo(Link)
